// extracted by mini-css-extract-plugin
export default {"container":"Dialogue_container__qznL8","list":"Dialogue_list__MYM6m","choice":"Dialogue_choice__OXEml","hide":"Dialogue_hide__ePRTT"};